









import Vue from 'vue'
import PartnerDetail from '../components/PartnerDetail.vue'

export default Vue.extend({
  components: {
      PartnerDetail
  },
  props:{
      id:Number,
  }
})
